<template>
  <div class="login">
    <div class="logo" v-if="ifFocus == 0">
      <img src="../assets/images/club-logo.png" />
    </div>
    <div class="logo onFocus" v-if="ifFocus == 1">
      <img src="../assets/images/club-logo.png" />
    </div>
    <div class="title" v-if="ifFocus == 0">Affiliate Program</div>
    <div class="title onFocus" v-if="ifFocus == 1">Affiliate Program</div>
    <div class="login-form">
      <div class="userNo">
        <p>Account</p>
        <input type="text" v-model="user.num" name="账号" placeholder="Please enter your account" />
        <span v-show="errors.has('账号')" class="help is-danger">{{ errors.first('账号') }}</span>
      </div>
      <div class="line"></div>
      <div class="passWord">
        <p>Password</p>
        <input
          type="password"
          v-model="user.password"
          v-validate
          data-vv-rules="password"
          name="密码"
          placeholder="Please enter your password"
        />
        <span v-show="errors.has('密码')" class="help is-danger">{{ errors.first('密码') }}</span>
      </div>
      <div class="btn_login" @click="signin">Login</div>
      <div class="foot-bottom">
        <img class="foot-bottom-1" src="../assets/image/foot-bottm-1.png" alt="" />
        <!-- <img class="foot-bottom-2" src="../assets/image/foot-bottm-2.png" alt="" /> -->
        <a href="https://www.tradeaiders.com" style="color:#fff;font-size: 0.5rem">www.tradeaiders.com</a>
      </div>
    </div>
  </div>
</template>

<script>
import storage from '../utils/storage'
import { Dialog } from 'vant'
import PartnerApi from '../api/partner'

export default {
  name: 'login',
  data() {
    return {
      ifFocus: 0,
      user: {
        num: '',
        password: ''
      }
    }
  },
  mounted: function() {
    if (window.localStorage) {
      // this.$router.replace('/home')
    }
  },
  methods: {
    signin() {
      this.$validator.validateAll()
      if (this.errors.any()) {
        return
      }
      let user = {
        password: this.user.password,
        account: this.user.num,
        userType: 1
      }
      PartnerApi.toLogin(user)
        .then(response => {
          let result = response.data
          let _this = this
          if (result.success) {
            let oldPasswd = this.user.password
            window.localStorage.oldPasswd = oldPasswd
            let user = result.data
            window.localStorage.num = this.user.num
            storage.setLocalStorage('user', user)
            this.$router.replace('/home')
          } else {
            Dialog.alert({
              message: result.msgEN,
              confirmButtonText: 'confirm'
            }).then(() => {
              // on close
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
      // this.$http.post(serverIP + '/bigshotuser/login', {
      //   'password': this.user.password,
      //   'userNo': this.user.num
      // }).then((response) => {
      //   let returnData = response.data
      //   if (returnData.success) {
      //     let oldPasswd = this.user.password
      //     window.localStorage.oldPasswd = oldPasswd
      //     let user = returnData.data
      //     window.localStorage.num = this.user.num
      //     // window.localStorage.user = JSON.stringify(user)
      //     storage.setLocalStorage('user', user)
      //     this.$router.replace('/home')
      //   } else {
      //     Dialog.alert({
      //       message: response.data.msg
      //     }).then(() => {
      //       // on close
      //     })
      //   }
      // }, (response) => {
      //   console.log('error')
      // })
    },
    iptFocus() {
      this.ifFocus = 1
    },
    iptBlur() {
      this.ifFocus = 0
    }
  }
}
</script>

<style scoped>
input::-webkit-input-placeholder {
  color: #fff;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #fff;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #fff;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}
@media (max-width: 750px) {
  .login {
    height: 100%;
    width: 100%;
    background: url('../assets/images/bg.png') repeat center center / 100%;
  }
  .logo {
    text-align: center;
    padding-top: 1rem;
    transition: opacity 0.8s;
  }
  .logo img {
    width: 7.5333rem;
    height: 7.5333rem;
  }
  .title {
    height: 1.7067rem;
    font-size: 1.0667rem;
    font-weight: 300;
    line-height: 1.7067rem;
    letter-spacing: 0.0213rem;
    text-align: center;
    margin-top: 0.576rem;
    color: #ffffff;
    transition: opacity 0.8s;
  }
  .onFocus {
    opacity: 0 !important;
  }
  .login-form {
    width: 100%;
    height: 10.18rem;
    background: rgba(255, 255, 255, 0.2);
    position: fixed;
    bottom: 0;
    left: 0;
  }
  .login .errorMsg {
    color: darkred;
    font-size: 0.6rem;
    background: none;
  }
  .userNo,
  .passWord {
    text-align: left;
    padding: 0.6187rem 0 0.1rem 1.0667rem;
  }
  .userNo span,
  .passWord span {
    display: block;
    font-size: 0.6rem;
    color: rgba(0, 0, 0, 0.8);
  }
  .passWord {
    position: relative;
  }
  .passWord > div {
    width: 1.0667rem;
    height: 1.0667rem;
    position: absolute;
    right: 1.0667rem;
    top: 0.9387rem;
  }
  .passWord > div > img {
    width: 100%;
    height: 100%;
  }
  .userNo p,
  .passWord p {
    height: 0.512rem;
    font-size: 0.512rem;
    letter-spacing: 0.0107rem;
    color: rgba(255, 255, 255, 1);
    /*margin-bottom: 0.3627rem;*/
  }
  .login-form input::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  .userNo input,
  .passWord input {
    height: 0.6973rem;
    width: 80%;
    line-height: 0.6973rem;
    font-size: 0.5973rem;
    letter-spacing: 0.0107rem;
    color: #ffffff;
    background: transparent;
    border: none;
    outline: none;
  }
  .line {
    width: 100%;
    height: 0.0427rem;
    background: rgba(255, 255, 255, 0.2);
  }
  .btn_login {
    width: 100%;
    height: 2.56rem;
    background: #f8b62d;
    text-align: center;
    line-height: 2.56rem;
    font-size: 0.64rem;
    color: #fff;
  }
}
@media (min-width: 750px) {
  .login {
    width: 750px;
    height: 1334px;
    background: url('../assets/images/bg.png') repeat center center / 100% 100%;
  }
  .logo {
    text-align: center;
    padding-top: 130px;
    transition: opacity 0.8s;
  }
  .logo img {
    width: 400px;
    height: 400px;
  }
  .title {
    font-size: 50px;
    font-weight: 300;
    text-align: center;
    margin-top: 27px;
    margin-bottom: 157px;
    color: #ffffff;
    transition: opacity 0.8s;
  }
  .onFocus {
    opacity: 0 !important;
  }
  .login-form {
    width: 100%;
    background: rgba(255, 255, 255, 0.2);
  }
  .login .errorMsg {
    color: darkred;
    font-size: 24px;
    background: none;
  }
  .userNo,
  .passWord {
    text-align: left;
    padding: 29px 50px;
  }
  .userNo span,
  .passWord span {
    display: block;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
  }
  .passWord {
    position: relative;
  }
  .passWord > div {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 40px;
    top: 38px;
  }
  .passWord > div > img {
    width: 100%;
    height: 100%;
  }
  .userNo p,
  .passWord p {
    height: 24px;
    font-size: 24px;
    color: rgba(255, 255, 255, 1);
    /*margin-bottom: 0.3627rem;*/
  }
  .userNo input,
  .passWord input {
    width: 80%;
    height: 32px;
    line-height: 32px;
    font-size: 28px;
    color: #ffffff;
    background: transparent;
    border: none;
    outline: none;
  }
  .login-form input::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  .line {
    width: 100%;
    height: 2px;
    background: rgba(255, 255, 255, 0.2);
  }
  .btn_login {
    width: 100%;
    height: 120px;
    background: #f8b62d;
    text-align: center;
    font-size: 30px;
    color: #fff;
    line-height: 120px;
  }
}
.foot-bottom {
  width: 50%;
  text-align: center;
  margin: 0.5rem auto 0;
}
.foot-bottom-1 {
  width: 80%;
  display: block;
  margin: 0 auto;
}
.foot-bottom-2 {
  width: 60%;
  display: block;
  margin: 7px auto 0;
}
</style>
